/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity'

const loadIToISlider = () => {
    if (document.querySelector('.i-to-i-gallery')) {
        /* eslint-disable no-new */
        new Flickity('.i-to-i-gallery', {
            dragThreshold: 30,
            freeScroll: false,
            prevNextButtons: false
        })
    }
}

export default loadIToISlider




// WEBPACK FOOTER //
// ./js/iToISlider.js